module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"New {{assetType}} asset"},"et":{"title":"New {{assetType}} asset"},"ru":{"title":"New {{assetType}} asset"}}')
  delete Component.options._Ctor
}
